export enum PosAttributes {
  full_access = 'Full Access',
  password = 'Password',
  manager_override = 'Manager override',
  manager_override_with_backout = 'Manager override with backout',
}

export type PosAttributesMapValue = {
  accessLevel: string;
  overrideRole?: string;
};
